// Hidden, link-only references / clients page. Minimal copy; the logo wall and
// the per-company entries (name, role, dates, url, logo path) live in the
// component. No em or en dashes anywhere.
const references = {
  seo: {
    title: 'Clients & references',
    description:
      'Universities, alliances, and studios Eduard Hvizdak has built AI systems for.',
  },
  back: 'Back home',
  eyebrow: 'Clients & references',
  title: 'Where I have worked',
  subtitle: 'Universities, alliances, and studios I have built production AI systems for.',
  currentLabel: 'Current',
  visit: 'Visit site',
};

export default references;
